module.exports = {
  api: {
    development: 'http://localhost:8000',
    staging: 'https://stgapi.renniemuseum.org:8001',
    production: 'https://api.renniemuseum.org:8001',
  },
  homeLink: {
    development: 'http://localhost:8000',
    staging: 'https://stg.renniemuseum.org',
    production: 'https://renniemuseum.org',
  },
};
